import { render, staticRenderFns } from "./ComponenteDialogoEdicion.vue?vue&type=template&id=835ab9f0&scoped=true&"
import script from "./ComponenteDialogoEdicion.vue?vue&type=script&lang=ts&"
export * from "./ComponenteDialogoEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteDialogoEdicion.vue?vue&type=style&index=0&id=835ab9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835ab9f0",
  null
  
)

export default component.exports